module.exports = __webpack_public_path__ + "static/flags/TO-75b2ba72417c16ec9a26def9a7ff4554.gif";